module.exports = __webpack_public_path__ + "img/advantage5.2dc442de.png";